import React from 'react';
import { MOTICARE_DATA } from '@/data/mock';
import { SolutionPageLayout } from '@/components/shared/SharedComponents';
import {
  Video, Brain, Apple, HeartPulse, Trophy, FileText,
  Shield, Building2, HardHat
} from 'lucide-react';

const featureIcons = { Video, Brain, Apple, HeartPulse, Trophy, FileText };
const audienceIcons = { Shield, Building2, HardHat };

export default function MotiCarePage() {
  return (
    <SolutionPageLayout
      heroData={MOTICARE_DATA.hero}
      features={MOTICARE_DATA.features}
      stats={MOTICARE_DATA.stats}
      audiences={MOTICARE_DATA.audiences}
      featureIcons={featureIcons}
      audienceIcons={audienceIcons}
    />
  );
}
